import JtChartMethods from './JtChartMethods.js'

export const jtChartMethods = { ...JtChartMethods }
